import React from 'react';
import { motion } from 'framer-motion';
import { SiblingFigure } from './characters/SiblingFigure';
import { siblings } from '../data/siblings';
import type { SiblingRole } from '../types/snak';
interface SiblingChoiceGridProps {
  selected: SiblingRole | null;
  onSelect: (role: SiblingRole) => void;
}
export function SiblingChoiceGrid({
  selected,
  onSelect
}: SiblingChoiceGridProps) {
  const odd = siblings.length % 2 === 1;
  return <div className="grid grid-cols-2 gap-3" data-id="element-406" data-mp="7nqyqqpy6u07">
      {siblings.map((sibling, i) => {
      const isSelected = selected === sibling.id;
      const dimmed = selected !== null && !isSelected;
      const wide = odd && i === siblings.length - 1;
      return <motion.button key={sibling.id} type="button" onClick={() => onSelect(sibling.id)} initial={{
        opacity: 0,
        y: 18,
        scale: 0.94
      }} animate={{
        opacity: dimmed ? 0.35 : 1,
        y: 0,
        scale: isSelected ? 1.03 : 1
      }} transition={{
        delay: selected ? 0 : 0.12 + i * 0.07,
        type: 'spring',
        stiffness: 320,
        damping: 24
      }} whileHover={{
        y: -3
      }} whileTap={{
        scale: 0.96
      }} style={{
        backgroundColor: sibling.surface
      }} className={['group relative overflow-hidden rounded-[22px] px-3 py-3 text-center', 'focus:outline-none focus-visible:ring-2 focus-visible:ring-background', wide ? 'flex items-center gap-3 text-left' : 'flex flex-col items-center', isSelected ? 'ring-2 ring-background shadow-[0_12px_30px_-14px_rgba(1,51,43,0.55)]' : 'ring-1 ring-[rgba(1,51,43,0.12)]'].join(' ')} aria-pressed={isSelected} data-id="element-407" data-mp="mbbxy9jpc92u" data-mpi={i}>
            <motion.span className={wide ? 'block shrink-0' : 'block'} animate={isSelected ? {
          y: [0, -6, 0],
          rotate: [0, -2, 0]
        } : {
          y: 0,
          rotate: 0
        }} transition={{
          duration: 0.6,
          ease: 'easeOut'
        }} data-id="element-408" data-mp="3nn47w68pbi8u">
              <SiblingFigure role={sibling.id} className={wide ? 'h-[58px] w-[58px]' : 'h-[84px] w-[84px]'} data-id="element-409" data-mp="1lrwy90jv5y01" />
            </motion.span>
            <span className={wide ? '' : 'contents'} data-id="element-410" data-mp="1c0k8cehmlhwn">
              <span className="mt-1 block font-heading text-[15px] leading-tight text-background" data-id="element-411" data-mp="1byzdenrefwy9">
                {sibling.label}
              </span>
              <span className="mt-0.5 block font-body text-[11px] leading-snug" style={{
            color: sibling.accent
          }} data-id="element-412" data-mp="24pzkj7l11gu5">
                {sibling.trait}
              </span>
            </span>
          </motion.button>;
    })}
    </div>;
}